<agr-page-detail
  (backAction)="openOverview()"
  backText="overview"
  [pageTitle]="(cropFieldAdvice$ | async)?.name + ' (' + (treatmentType | translate) + ')'"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  primaryActionText="addTreatment"
  (primaryAction)="addTreatment()"
  [hasSecondaryAction]="true"
  [stickyToolbar]="true"
  [stickyDetails]="true"
  secondaryActionIcon="post_add"
  secondaryActionText="selectSchema"
  (secondaryAction)="selectSchema()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
  class="advice-page-container"
>
  <ng-container details *ngrxLet="cropFieldAdvice$ as cropFieldAdvice">
    <div class="flex--row">
      <div
        class="spacing--margin-half-vertical spacing--padding-half-vertical spacing--margin-right"
      >
        @if (chipList.length > 0) {
          <mat-chip-listbox>
            @for (chip of chipList; track chip) {
              @if (chip.condition) {
                <mat-chip-option
                  [selected]="true"
                  [selectable]="false"
                  [color]="chip.color || null"
                  [ngClass]="chip.class"
                >
                  @if (chip.icon) {
                    <mat-icon matChipAvatar>{{ chip.icon }}</mat-icon>
                  }
                  {{ chip.label | translate }}
                </mat-chip-option>
              }
            }
          </mat-chip-listbox>
        }
      </div>
      <div class="spacing--margin-half-vertical flex__child--none flex--row flex--nowrap">
        <div class="flex__child--none spacing--margin-right">
          <div class="text--label">{{ 'crop' | translate }}</div>
          {{ (cropFieldAdvice$ | async)?.crop?.name }}
          @if ((cropFieldAdvice$ | async)?.cropVariety) {
            <div>({{ (cropFieldAdvice$ | async)?.cropVariety?.name }})</div>
          }
        </div>
        <div class="flex__child--none spacing--margin-right">
          <div class="text--label">{{ 'soilType' | translate }}</div>
          {{ (cropFieldAdvice$ | async)?.soilType?.name }}
        </div>
        <div class="flex__child--none spacing--margin-right">
          <div class="text--label">{{ 'area' | translate }}</div>
          {{ (cropFieldAdvice$ | async)?.areaInHectares | agrNumber }} Ha
        </div>
        <div class="flex__child--none spacing--margin-right">
          <div class="text--label">{{ 'period' | translate }}</div>
          {{ (cropFieldAdvice$ | async)?.startDate | agrDate }} /
          {{ (cropFieldAdvice$ | async)?.endDate | agrDate }}
        </div>
      </div>
      @if (isFertilizationAdvice) {
        <app-fertilization-legal-standards-quick-view
          class="flex__child--none spacing--margin-half-vertical"
        ></app-fertilization-legal-standards-quick-view>
      }
      @if (isFertilizationAdvice) {
        <app-nitrogen-cuts
          class="flex__child--none spacing--margin-half-vertical"
        ></app-nitrogen-cuts>
      }
      @if (isFertilizationAdvice) {
        <app-organic-matter-quick-view
          class="flex__child--none spacing--margin-half-vertical"
        ></app-organic-matter-quick-view>
      }
      @if (!isFertilizationAdvice) {
        <app-environmental-impact-quick-view
          class="flex__child--none spacing--margin-half-vertical"
        ></app-environmental-impact-quick-view>
      }
      @if (isFertilizationAdvice) {
        <app-soil-analysis-quick-view
          class="soil-analysis-quick-view flex__child--none spacing--margin-half-vertical"
        ></app-soil-analysis-quick-view>
      }
      <ng-container *ngrxLet="cropFieldAdvice$ as cropFieldAdvice">
        @if (cropFieldAdvice?.isSkal && isFertilizationAdvice) {
          <app-skal-report-quick-view
            class="flex__child--none spacing--margin-half-vertical"
          ></app-skal-report-quick-view>
        }
      </ng-container>
    </div>
    <app-copy-advice-status></app-copy-advice-status>
  </ng-container>
  @if ((areTreatmentsValid$ | async) === false) {
    <div class="notification notification-error spacing--margin-horizontal">
      <mat-icon>warn</mat-icon>
      {{ 'invalidTreatments' | translate }}
    </div>
  }

  <mat-list data-test="executed-treatments-list">
    <ng-container
      *ngFor="let treatment of executedTreatmentsWithActions$ | async as treatments; let i = index"
    >
      @if (
        isFirstTreatmentInPeriod(treatment, treatments, i) &&
          getSalesOrderPeriod(
            salesOrderPeriods$ | async,
            pastSalesOrderPeriods$ | async,
            treatment.periodId
          );
        as salesOrderPeriod
      ) {
        <h3 matSubheader>
          <strong>{{ previousCropYear$ | async }}</strong> &nbsp;
          <span>{{ 'period' | translate }}</span> &nbsp;
          <span>{{ salesOrderPeriod?.name }}</span> &nbsp;
          <span
            >{{ 'from' | translate }}
            {{ salesOrderPeriod.startDispatchFrom | agrDate: 'shortDate' }}
            {{ 'until' | translate }}
            {{ salesOrderPeriod.deliverBefore | agrDate: 'shortDate' }}</span
          >&nbsp; <span>{{ '(' + ('isAnExecutedTreatment' | translate | lowercase) + ')' }}</span>
        </h3>
      }
      <mat-list-item data-test="executed-treatments-item">
        @if (treatment.frequency <= 1) {
          <mat-icon matListItemIcon>short_text</mat-icon>
        }
        @if (treatment.frequency > 1) {
          <mat-icon matListItemIcon>cached</mat-icon>
        }
        <h2 matListItemTitle>
          {{ treatment.name }}
          @if (hasDivergentHectares(treatment.areaInHectaresManual, cropFieldAdvice$ | async)) {
            <span
              >&nbsp;({{ treatment.areaInHectaresManual | agrNumber }}
              <span class="hectares">Ha</span>)</span
            >
          }
          @if (treatment.frequency > 1) {
            <span>&nbsp;({{ treatment.frequency }} {{ 'amountOfRepetitions' | translate }})</span>
          }
        </h2>
        <p matListItemLine>{{ treatment.objective | translate }}</p>
        <span matListItemLine>
          {{ getCropAidAdviceNamesAndDosages$(treatment.aidAdvices) | async }}</span
        >
        <agr-responsive-actions
          matListItemMeta
          [showLabels]="false"
          [items]="treatment.actions"
          (action)="executedTreatmentAction($event, treatment)"
        ></agr-responsive-actions>
      </mat-list-item>
    </ng-container>
  </mat-list>

  <mat-list data-test="treatments-list">
    <ng-container
      *ngFor="let treatment of treatmentsWithActions$ | async as treatments; let i = index"
    >
      @if (
        isFirstTreatmentInPeriod(treatment, treatments, i) &&
          getSalesOrderPeriod(
            salesOrderPeriods$ | async,
            pastSalesOrderPeriods$ | async,
            treatment.periodId
          );
        as salesOrderPeriod
      ) {
        <h3 matSubheader>
          <strong>{{ cropYear$ | async }}</strong> &nbsp;
          <span>{{ 'period' | translate }}</span> &nbsp;
          <span>{{ salesOrderPeriod?.name }}</span> &nbsp;
          <span
            >{{ 'from' | translate }}
            {{ salesOrderPeriod.startDispatchFrom | agrDate: 'shortDate' }}
            {{ 'until' | translate }}
            {{ salesOrderPeriod.deliverBefore | agrDate: 'shortDate' }}</span
          >
        </h3>
      }
      <mat-list-item data-test="treatments-item">
        @if (treatment.isCorrupt === false && treatment.frequency <= 1) {
          <mat-icon matListItemIcon>short_text</mat-icon>
        }
        @if (treatment.isCorrupt === false && treatment.frequency > 1) {
          <mat-icon matListItemIcon>cached</mat-icon>
        }
        @if (!isTreatmentValid(treatment)) {
          <mat-icon matListItemIcon color="warn">error</mat-icon>
        }
        <h2 matListItemTitle>
          {{ treatment.name }}
          @if (hasDivergentHectares(treatment.areaInHectaresManual, cropFieldAdvice$ | async)) {
            <span
              >&nbsp;({{ treatment.areaInHectaresManual | agrNumber
              }}<span class="hectares">Ha</span>)</span
            >
          }
          @if (treatment.frequency > 1) {
            <span>&nbsp;({{ treatment.frequency }} {{ 'amountOfRepetitions' | translate }})</span>
          }
        </h2>
        <span matListItemLine>{{ treatment.objective | translate }}</span>
        <span matListItemLine>{{
          getCropAidAdviceNamesAndDosages$(treatment.aidAdvices) | async
        }}</span>
        <agr-responsive-actions
          matListItemMeta
          [showLabels]="false"
          [items]="treatment.actions"
          (action)="treatmentAction($event, treatment)"
        ></agr-responsive-actions>
      </mat-list-item>
    </ng-container>
  </mat-list>

  @if (isFertilizationAdvice && (tableReportData$ | async)) {
    <app-fertilization-table
      [tableReportData$]="tableReportData$"
      [isCollapsable]="false"
    ></app-fertilization-table>
  }
</agr-page-detail>
